import { units } from '@ui/css';
import { makeSelectors, combineTokens } from '@utils/css';

const iconFadeDurationMs = 150;
combineTokens("--ui-fab", {
  size: units.px(50)
});
const wrapper = "dibw19cxj4o";
const icon = "dibig4xkmt";
const checkmark = "dibc1foh53b";
const floatingActionButtonSelectors = makeSelectors({
  wrapper
});

export { checkmark, floatingActionButtonSelectors, icon, iconFadeDurationMs, wrapper };
import "./fab.style.linaria.module.css";
//# sourceMappingURL=fab.style.js.map
